import React, { useRef } from 'react';
import './chapters.scss';
import Hyperlink from '../Hyperlink/Hyperlink';
import InlinePhotos from '../InlinePhotos/InlinePhotos';
import Float from '../Float/Float';

function Chapter6() {
  const inline7Ref = useRef();
  const float3Ref = useRef();
  const hyperlinkData = [
    {
      origin: '',
      href: 'https://www.spravato.com/?utm_source=CNN&utm_medium=Article&utm_campaign=SPR_SponCon&utm_id=Patient_Article',
      a: 'SPRAVATO®'
    },
    {
      origin: '',
      jump: '#isi',
      a: 'here'
    }
  ];
  return (
    <div className="chapters__chapter">
      <h3>Finding an Innovative Treatment</h3>
      <p className="chapters__chapter__paragraph">
        The experiences of Ben, Grace, and Allison and their search for other treatment options in
        combination with an oral antidepressant led them to learn about{' '}
        <Hyperlink hyperlinkData={hyperlinkData[0]} /> (esketamine) CIII nasal spray, which is
        indicated for adults with TRD and to treat depressive symptoms in adults with MDD with acute
        suicidal thoughts or actions.
      </p>
      <div className="chapters__chapter__infobox chapters__chapter__infobox--border">
        SPRAVATO® is not for use as a medicine to prevent or relieve pain (anesthetic). It is not
        known if SPRAVATO® is safe and effective as an anesthetic medicine. It is not known if
        SPRAVATO® is safe and effective for use in preventing suicide or in reducing suicidal
        thoughts or actions. SPRAVATO® is not for use in place of hospitalization if your healthcare
        provider determines that hospitalization is needed, even if improvement is experienced after
        the first dose of SPRAVATO®. It is not known if SPRAVATO® is safe and effective in children.
        (Please see additional Important Safety Information, including BOXED WARNINGS, limitations
        of use, and a list of side effects below. Click{' '}
        <Hyperlink hyperlinkData={hyperlinkData[1]} />
        ).
      </div>
      <p className="chapters__chapter__paragraph">
        Most commonly prescribed oral antidepressants (i.e., SSRIs and SNRIs) focus on targeting the
        same neurotransmitters (serotonin, norepinephrine and dopamine) in the brain and have for
        decades.<sup>4</sup> SPRAVATO® is different in that it blocks receptors in the brain called
        N-methyl-D-aspartate (NMDA) receptors and, although the exact mechanism is unknown, clinical
        studies have shown that when NMDA receptors are blocked by esketamine, they can have an
        antidepressant effect in TRD patients.<sup>5</sup> Grace remembers reading about the
        treatment for the first time: “I read about how it worked differently than current treatment
        options,” she says, “and I just decided that I can't give up.”
      </p>
      <InlinePhotos index={7} size={'content'} inlineRef={inline7Ref} />
      <p className="chapters__chapter__paragraph">
        They discussed the risks and benefits of the medication with their doctors, including the
        most serious side effects, such as sedation, dissociation, respiratory depression as well as
        the risk of abuse and misuse.<sup>5</sup> Their doctors explained that to help ensure
        patient safety, SPRAVATO® is only available through a restricted distribution program called
        the SPRAVATO® Risk Evaluation and Mitigation Strategy (REMS) program. This means they would
        be under the direct supervision of their healthcare provider while they self-administer the
        nasal spray and are monitored for at least two hours afterwards to keep track of any serious
        side effects.
      </p>
      <p className="chapters__chapter__paragraph">
        After several weeks of treatment on SPRAVATO®, Allison said that Austin’s depressive
        symptoms began to improve. “I started to see glimmers of hope that I hadn’t seen until this
        point,” she says. Now, after four years of treatment, Allison proudly reports that Austin
        has returned to college, where he’s majoring in computer engineering and earning a 4.0 GPA.
      </p>
      <div className="chapters__chapter__float">
        <Float index={2} floatRef={float3Ref} />
        <p className="chapters__chapter__paragraph">
          “Looking back at when my clinical depression was at its worst,” Ben says, “I would have
          said my career was done. But today, my depressive symptoms are under control, thanks to
          the combination of my oral antidepressant, therapy and SPRAVATO® treatment.” Now, he’s
          begun a new chapter in his life, making travel plans and celebrating his one-year
          anniversary at a new company.
        </p>
      </div>
      <p className="chapters__chapter__paragraph">
        "While this medication may not work for everyone,” Grace says, “combined with my oral
        antidepressant, it was the right choice for me and has become an essential part of my
        treatment plan, which also includes talking with my therapist and loved ones, getting
        outside on a hike, or finding a creative outlet in art.”
      </p>
    </div>
  );
}

export default Chapter6;
